import '../scss/reset.scss'
import '../scss/fonts.scss'
import 'path-intersection'
// import '../scss/main.scss'




let intersect = require('path-intersection');

// var path0 = "M 24.379464,51.504463 23.434524,23.156249 38.742559,12.572916 c 0,0 29.860118,-9.0714281 17.00893,0.755953 -12.851191,9.82738 13.229166,19.465774 13.229166,19.465774 z"
// var path1 = "m 32.883928,0.28869028 c 0,0 -15.686011,1.51190452 -8.504463,7.18154712 7.181546,5.6696426 50.270836,30.0491076 26.458332,42.3333336 -23.8125,12.284226 47.058036,14.174107 47.058036,14.174107 z"

// // let path0 = 'M30,100L270,20';
// // let path1 = 'M150,150m0,-18a18,18,0,1,1,0,36a18,18,0,1,1,0,-36z';
// let intersection = intersect(path0, path1);
// console.log(intersection);

// // console.log(123);
$(document).ready(function(){
    let path__vozrast = '';
    let path__sudba = '';
    let path__volya = '';
    let k = 6;
    // let k = 6.162464985994398;
    
    $('.step-2-button-go').on('click', function(e){
        e.preventDefault();

        setTimeout(function(){
            path__vozrast = $('.svg-wrapper svg path.svg-line-vozrast').attr('d');
            path__sudba = $('.svg-wrapper svg path.svg-line-sudba').attr('d');
            path__volya = $('.svg-wrapper svg path.svg-line-volya').attr('d');

            let intersection__sudba = intersect(path__vozrast, path__sudba);
            intersection__sudba = (intersection__sudba[0].y / k).toFixed(2);
            $('.chisla-item[data-id="sudba_segodnya"] .chisla-item-right').html( intersection__sudba );

            let intersection__volya = intersect(path__vozrast, path__volya);
            intersection__volya = (intersection__volya[0].y / k).toFixed(2);
            $('.chisla-item[data-id="volya_segodnya"] .chisla-item-right').html( intersection__volya );
// console.log(intersection__volya);
            
        }, 1000);
        
        // setInterval(function(i){
        //     path__vozrast = $('.svg-wrapper svg path.svg-line-vozrast').attr('d');
        //     if( path__vozrast != undefined ){
        //         return false;
        //     }
        //     console.log(i);
        // }, 50);
        
        // setInterval(function(i){
        //     path__sudba = $('.svg-wrapper svg path.svg-line-sudba').attr('d');
        //     if( path__sudba != undefined ){
        //         return false;
        //     }
        //     console.log(i);
        // }, 50);
        
        // setInterval(function(i){
        //     path__volya = $('.svg-wrapper svg path.svg-line-volya').attr('d');
        //     if( path__volya != undefined ){
        //         return false;
        //     }
        //     console.log(i);
        // }, 50);

        
        // setInterval(function(i){
        //     if( path__vozrast != undefined  &&  path__sudba != undefined  &&  path__volya != undefined ){
        //     //     let intersection__sudba = intersect(path__vozrast, path__sudba);
        //     //     console.log(intersection__sudba);

        //         return false;
        //     }
        // }, 350);
        

    });

    
});




// let p1 = `
//     M 19 0
//     L 19 54
//     Z
// `;

// let p2 = `
//     M 0  18
//     L 12 36
//     L 24 12
//     L 36 6
//     L 48 24
//     L 60 12
//     L 72 24

//     L 72 24
//     L 60 12
//     L 48 24
//     L 36 6
//     L 24 12
//     L 12 36
//     M 0  18
//     Z
// `;

// let p3 = `

//                     M 0  18
//                     L 12 48
//                     L 24 24
//                     L 36 6
//                     L 48 24
//                     L 60 18
//                     L 72 24
                    
//                     L 72 24
//                     L 60 18
//                     L 48 24
//                     L 36 6
//                     L 24 24
//                     L 12 48
//                     M 0  18
//                     Z
                
// `;

// let intersection = intersect(p1, p3);
// console.log(intersection);

